
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "stretch": "stretch-41a0eb3d",
    "fit": "fit-41a0eb3d"
};
exports.styleSource = ".stretch-41a0eb3d{flex:auto;position:relative}.fit-41a0eb3d{width:100%;height:100%}.fit-41a0eb3d>div{position:absolute;top:0;left:0;width:100%;height:100%}";
exports.default = exports.styles;
            
module.moduleType = "style";
